const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        sorter: (a, b) => a?.name?.localeCompare(b?.name),
    },
    {
        title: 'Email',
        dataIndex: 'email',
        sorter: (a, b) => a?.email?.localeCompare(b?.email),
    },
    {
        title: 'Account',
        dataIndex: 'account',
        sorter: (a, b) => a?.account?.localeCompare(b?.account),
    },
    {
        title: 'Commission Date',
        dataIndex: 'commissionDate',
        sorter: (a, b) => a?.commissionDate?.localeCompare(b?.commissionDate),
    },
    {
        title: 'Plan Name',
        dataIndex: 'planName',
        sorter: (a, b) => a?.planName?.localeCompare(b?.planName),
    },
    {
        title: 'IB/User',
        dataIndex: 'userTypt',
        sorter: (a, b) => a?.userTypt?.localeCompare(b?.userTypt),
    },
    {
        title: 'Affiliate Code',
        dataIndex: 'affiliateCode',
        sorter: (a, b) => a?.affiliateCode?.localeCompare(b?.affiliateCode),
    },
    {
        title: 'Lots',
        dataIndex: 'lots',
        sorter: (a, b) => a?.lots - b?.lots,
    },
    {
        title: 'IB Commission',
        dataIndex: 'commission',
        sorter: (a, b) => a?.commission - b?.commission,
    },
];

export default columns;